import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { API_BASE_URL } from 'src/apiConfig';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LoadingOverlay } from 'src/scenes/students/administration/helper/const';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';

const ChooseSchoolForReview = () => {
  const { t } = useTranslation();
  const [schools, setSchools] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  //for dailog

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [selectedSchoolId, setSelectedSchoolId] = useState(null);

  useEffect(() => {
    setIsLoading(true);

    fetch(`${API_BASE_URL}/api/connectingWork.php?action=getNotConnectWork`)
      .then((response) => response.json())
      .then((data) => setSchools(data))
      .catch((error) => console.error('Error fetching data:', error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleReviewClick = (schoolId) => {
    const reviewerName = localStorage.getItem('username').slice(1, -1) || ''; // Preuzmite ime pregledača

    // Pošaljite zahtev back-endu da započnete pregledanje
    axios
      .post(`${API_BASE_URL}/api/schools.php`, {
        action: 'startReviewingSchool',
        schoolId: schoolId,
        reviewerName: reviewerName
      })
      .then((response) => {
        if (response.data.success) {
          navigate(`/review-schools-students?schoolId=${schoolId}`);
        } else {
          const status = response.data.status;
          const existingReviewer = response.data.reviewer;

          let message = '';
          if (status === 'zavrseno') {
            message = t('review.finishedMessage', {
              reviewer: existingReviewer
            });
          } else if (status === 'pregledanje') {
            message = t('review.inProgressMessage', {
              reviewer: existingReviewer
            });
          } else {
            message = t('review.unknownStatusMessage');
          }

          setDialogMessage(message);
          setSelectedSchoolId(schoolId);
          setOpenDialog(true);
        }
      })
      .catch((error) => {
        console.error('There was an error starting the review!', error);
      });
  };

  const handleProceedAnyway = () => {
    setOpenDialog(false);
    navigate(`/review-schools-students?schoolId=${selectedSchoolId}`);
  };

  const columns = [
    { field: 'id', headerName: t('review.id'), width: 90 },
    { field: 'name', headerName: t('review.school_name'), width: 310 },
    {
      field: 'studentCountConnect',
      headerName: t('review.connected_works_count'),
      width: 180
    },
    {
      field: 'status',
      headerName: t('review.status'),
      width: 150
    },
    {
      field: 'profesor_name',
      headerName: t('review.professor_name'),
      width: 200
    },
    {
      field: 'action',
      headerName: t('review.action'),
      width: 180,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleReviewClick(params.row.id)}
          style={{
            backgroundColor: '#4cceac',
            color: '#fff',
            fontWeight: 'bold',
            textTransform: 'none',
            borderRadius: '8px'
          }}
        >
          {t('review.review')}
        </Button>
      )
    }
  ];

  const rows = schools
    .filter((school) => school.studentCountConnect > 0)
    .map((school) => {
      let statusInCyrillic = '';
      switch (school.status) {
        case 'zavrseno':
          statusInCyrillic = t('review.completed');
          break;
        case 'pregledanje':
          statusInCyrillic = t('review.in_progress');
          break;
        default:
          statusInCyrillic = t('review.not_started');
          break;
      }

      const profesorName =
        school.profesor_name === 'N/A' ? '-' : school.profesor_name;

      return {
        id: school.id,
        name: school.name,
        studentCount: school.studentCount,
        studentCountConnect: school.studentCountConnect,
        status: statusInCyrillic, // Koristimo premapiran status na ćirilicu
        profesor_name: profesorName // Ako je N/A, postavlja crtica
      };
    });

  return (
    <div
      style={{
        height: 600,
        width: '100%',
        backgroundColor: '#f5f5f5',
        padding: '20px',
        borderRadius: '16px'
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
        checkboxSelection={false}
        disableColumnFilter
        loading={isLoading}
        components={{
          LoadingOverlay: LoadingOverlay
        }}
        disableColumnMenu
        componentsProps={{
          pagination: {
            labelRowsPerPage: t('pagination.rowsPerPage'),
            labelDisplayedRows: ({ from, to, count }) =>
              `${from}-${to} ${t('pagination.of')} ${
                count !== -1 ? count : `${t('pagination.moreThan')} ${to}`
              }`
          }
        }}
        sx={{
          boxShadow: 2,
          borderRadius: '16px',
          backgroundColor: '#ffffff',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#3788d8',
            color: '#fff',
            fontSize: '16px',
            fontWeight: 'bold',
            borderBottom: '2px solid #ddd'
          },
          '& .MuiDataGrid-cell': {
            color: '#0d47a1',
            fontSize: '14px'
          },
          '& .MuiDataGrid-footerContainer': {
            backgroundColor: '#e3f2fd',
            borderTop: '1px solid #ddd'
          }
        }}
      />

      {/* Dialog za upozorenje */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>{t('review.dialogTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            {t('review.cancel')}
          </Button>
          <Button onClick={handleProceedAnyway} color="secondary">
            {t('review.proceed')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ChooseSchoolForReview;
